import React from "react";

import { ImageChooserBlock as ImageChooserBlockValue } from "@reactivated";

import { concatClassNames } from "../../utils/styles";
import { ImageRenditionSet } from "../ImageRenditionSet";

import styles from "./index.module.scss";

export const ImageChooserBlock = (props: {
    value: ImageChooserBlockValue;
    /** Attributes are set on the picture element */
    attrs?: React.HTMLAttributes<HTMLPictureElement>;
    /** Attributes are set on the image element */
    imageAttrs?: React.ImgHTMLAttributes<HTMLImageElement>;
    renditionNames?: Set<string>;
}) => {
    const attrs = props.attrs || {};
    attrs.className = concatClassNames([attrs.className, styles.picture]);
    const imageAttrs = props.imageAttrs || {};
    imageAttrs.className = concatClassNames([imageAttrs.className, styles.img]);
    if (!imageAttrs.alt) {
        imageAttrs.alt = props.value.title;
    }
    // Find all the renditions we should use for the srcSet, and sort them from smallest to largest filesize
    const renditions = Object.entries(props.value.renditions)
        .filter(([name, rendition]) => {
            return (
                props.renditionNames === undefined ||
                props.renditionNames.has(name)
            );
        })
        .map(([, rendition]) => rendition);
    return (
        <ImageRenditionSet
            renditions={renditions}
            attrs={attrs}
            imageAttrs={imageAttrs}
        />
    );
};
